import React, { useEffect } from 'react';
import { useStateValue } from '../store/store';
import { STEPS } from './util';

const Steps = () => {
	const [{ currentIndex }] = useStateValue();
	let current = STEPS[currentIndex];

	useEffect(() => {
		let previousIndex = parseInt(currentIndex) - 1;
		let nextIndex = parseInt(currentIndex) + 1;

		if (nextIndex > 0 && nextIndex < STEPS.length) {
			document.body.classList.remove(STEPS[nextIndex].class)
		}

		if (previousIndex > 0) {
			document.body.classList.remove(STEPS[previousIndex].class)
		}

		document.body.classList.add(STEPS[currentIndex].class)
	});

	return (
		<div className="step">
			{
				current && current.content
			}
		</div>
	)
}

export default Steps;
